import { MiddlewareManager } from '@makemydeal/dr-activities-open-deal-v2';
import { MiddlewareAPI } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import { configureOpenDeal } from './config';

export let cachedOpenDealMiddlewareManager: MiddlewareManager | undefined;

// needed for testing
export const openDealMiddlewareClearCache = () => (cachedOpenDealMiddlewareManager = undefined);

export const openDealMiddleware = (store: MiddlewareAPI) => (next: any) => (action: AnyFSA) => {
    if (action.type === bootstrapActionTypes.BOOTSTRAP_SUCCESS) {
        cachedOpenDealMiddlewareManager = configureOpenDeal();
    }

    if (cachedOpenDealMiddlewareManager) {
        cachedOpenDealMiddlewareManager.middleware(store)(next)(action);
    } else {
        next(action);
    }
};
